package ai.wagemix.web.screens.appshell

import com.varabyte.kobweb.compose.css.TextOverflow
import com.varabyte.kobweb.compose.css.WhiteSpace
import com.varabyte.kobweb.compose.ui.modifiers.textOverflow
import com.varabyte.kobweb.compose.ui.modifiers.whiteSpace
import com.varabyte.kobweb.compose.ui.modifiers.color
import ai.wagemix.web.theme.WMCaptionTextStyle
import ai.wagemix.web.theme.WMLabelStrongTextStyle
import ai.wagemix.web.theme.WMLabelTextStyle
import com.varabyte.kobweb.silk.components.text.SpanText
import org.w3c.dom.events.KeyboardEvent
import kotlinx.browser.window
import kotlinx.browser.document
import com.varabyte.kobweb.compose.ui.thenIf
import com.varabyte.kobweb.compose.ui.attrsModifier
import com.varabyte.kobweb.compose.ui.styleModifier
import com.varabyte.kobweb.compose.ui.modifiers.pointerEvents
import com.varabyte.kobweb.compose.ui.modifiers.opacity
import com.varabyte.kobweb.compose.css.PointerEvents
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.DisposableEffect
import ai.wagemix.web.components.WMIconButton
import ai.wagemix.web.theme.WMTightGapVar
import ai.wagemix.web.theme.WMDrawerTransitionVar
import ai.wagemix.logic.WMPlanRules
import ai.wagemix.logic.WMRoutes
import ai.wagemix.logic.appshell.WMAppShellPresenter
import ai.wagemix.logic.appshell.WMAppShellPresenter.Action
import ai.wagemix.logic.appshell.WMAppShellPresenter.Event
import ai.wagemix.logic.appshell.WMPlanSummary
import ai.wagemix.net.models.WMSession
import ai.wagemix.net.models.WMStoredMix
import ai.wagemix.net.models.firebase.WMSubscriptionType
import ai.wagemix.web.components.WMAppSidebar
import ai.wagemix.web.components.WMAppTopBar
import ai.wagemix.web.components.WMAvatar
import ai.wagemix.web.components.WMBadge
import ai.wagemix.web.components.WMBadgeKind
import ai.wagemix.web.components.WMButton
import ai.wagemix.web.components.WMButtonKind
import ai.wagemix.web.components.WMButtonSize
import ai.wagemix.web.components.WMFormat
import ai.wagemix.web.components.WMIconGlyph
import ai.wagemix.web.components.WMNavItem
import ai.wagemix.web.components.WMPlanSummaryCard
import ai.wagemix.web.components.WMRenewalBanner
import ai.wagemix.web.components.WMSidebarItem
import ai.wagemix.web.screens.WMWebStrings
import ai.wagemix.web.screens.planName
import ai.wagemix.web.theme.WMPageGutterCompactVar
import ai.wagemix.web.theme.WMAppContentGapVar
import ai.wagemix.web.theme.WMSidebarWidthVar
import androidx.compose.runtime.Composable
import androidx.compose.runtime.State
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import com.fsryan.foundation.web.screens.FSWebScreen
import com.fsryan.foundation.web.theme.FSBreakpoint
import com.fsryan.foundation.web.theme.fs
import com.varabyte.kobweb.compose.css.Overflow
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.bottom
import com.varabyte.kobweb.compose.ui.modifiers.display
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxSize
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.flexBasis
import com.varabyte.kobweb.compose.ui.modifiers.flexGrow
import com.varabyte.kobweb.compose.ui.modifiers.flexShrink
import com.varabyte.kobweb.compose.ui.modifiers.gap
import com.varabyte.kobweb.compose.ui.modifiers.left
import com.varabyte.kobweb.compose.ui.modifiers.maxWidth
import com.varabyte.kobweb.compose.ui.modifiers.minHeight
import com.varabyte.kobweb.compose.ui.modifiers.minWidth
import com.varabyte.kobweb.compose.ui.modifiers.onClick
import com.varabyte.kobweb.compose.ui.modifiers.overflow
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.modifiers.position
import com.varabyte.kobweb.compose.ui.modifiers.right
import com.varabyte.kobweb.compose.ui.modifiers.top
import com.varabyte.kobweb.compose.ui.modifiers.width
import com.varabyte.kobweb.compose.ui.modifiers.zIndex
import com.varabyte.kobweb.silk.style.CssStyle
import com.varabyte.kobweb.silk.style.base
import com.varabyte.kobweb.silk.style.breakpoint.Breakpoint
import com.varabyte.kobweb.silk.style.breakpoint.displayIfAtLeast
import com.varabyte.kobweb.silk.style.breakpoint.displayUntil
import com.varabyte.kobweb.silk.style.toModifier
import com.varabyte.kobweb.silk.theme.colors.ColorMode
import com.varabyte.kobweb.silk.theme.colors.palette.toPalette
import org.jetbrains.compose.web.css.DisplayStyle
import org.jetbrains.compose.web.css.Position
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.css.vh

/**
 * The scrim behind the phone drawer. It stays in the page so it can fade; closed, it is transparent and lets clicks
 * through ([WMDrawerScrimOpenStyle] shows it).
 */
val WMDrawerScrimStyle = CssStyle.base {
    Modifier
        .position(Position.Fixed)
        .top(0.px).left(0.px).right(0.px).bottom(0.px)
        .backgroundColor(colorMode.toPalette().fs.scrim)
        .zIndex(40)
        .opacity(0)
        .pointerEvents(PointerEvents.None)
        .styleModifier { property("transition", "opacity ${WMDrawerTransitionVar.value()} ease") }
}

val WMDrawerScrimOpenStyle = CssStyle.base {
    Modifier.opacity(1).pointerEvents(PointerEvents.Auto)
}

/**
 * The phone drawer: the sidebar sliding in from the left edge. It stays in the page so it can slide out again; closed,
 * it is off screen and hidden once the slide ends ([WMDrawerOpenStyle] brings it in).
 */
val WMDrawerStyle = CssStyle.base {
    Modifier
        .position(Position.Fixed)
        .top(0.px).left(0.px).bottom(0.px)
        .width(WMSidebarWidthVar.value())
        .zIndex(41)
        .overflow(Overflow.Auto)
        .styleModifier {
            property("transform", "translateX(-100%)")
            property("visibility", "hidden")
            // Hidden only after the slide out has finished.
            val duration = WMDrawerTransitionVar.value()
            property("transition", "transform $duration ease, visibility 0s linear $duration")
        }
}

val WMDrawerOpenStyle = CssStyle.base {
    Modifier.styleModifier {
        property("transform", "translateX(0)")
        property("visibility", "visible")
        property("transition", "transform ${WMDrawerTransitionVar.value()} ease, visibility 0s linear 0s")
    }
}

/** For visitors who asked for reduced motion: the drawer and its scrim appear and disappear at once. */
val WMNoTransitionStyle = CssStyle.base {
    Modifier.styleModifier { property("transition", "none") }
}

/** The drawer's close button, in its top-right corner. */
val WMDrawerCloseStyle = CssStyle.base {
    Modifier.position(Position.Absolute).top(WMTightGapVar.value()).right(WMTightGapVar.value())
}

val WMAppMainStyle = CssStyle {
    base { Modifier.fillMaxWidth().minWidth(0.px).padding(WMPageGutterCompactVar.value()).gap(WMAppContentGapVar.value()) }
    FSBreakpoint.Large { Modifier.padding(32.px) }
}

/**
 * The logged-in chrome (Penpot `App shell`): sidebar at Large, a drawer behind a menu button on
 * phones, the top bar, and the page's content. The site's `@Layout` wraps its pages in this.
 */
@Composable
fun <E: Event, A: Action, PR: WMAppShellPresenter<E, A>, VM: WMBaseAppShellWebViewModel<E, A, PR>> WMAppShellScreen(
    createViewModel: () -> VM,
    strings: WMWebStrings,
    activePath: String,
    pageTitle: String,
    logo: @Composable () -> Unit,
    themeToggle: @Composable () -> Unit,
    modifier: Modifier = Modifier,
    topBarActions: (@Composable () -> Unit)? = null,
    /** Chrome for a visitor without a session (the marketing wrap of the logged-out builder); `null` keeps the shell. */
    loggedOutChrome: (@Composable (content: @Composable () -> Unit) -> Unit)? = null,
    content: @Composable () -> Unit
) {
    FSWebScreen(createViewModel = createViewModel) { vm ->
        if (loggedOutChrome != null && !vm.sessionResolvedState.value) {
            return@FSWebScreen   // nothing until the session is known, so the chrome never flips
        }
        if (loggedOutChrome != null && vm.sessionState.value == null) {
            loggedOutChrome(content)
            return@FSWebScreen
        }
        WMAppShellLayout(
            strings = strings,
            activePath = activePath,
            pageTitle = pageTitle,
            sessionState = vm.sessionState,
            planState = vm.planState,
            mixCountState = vm.mixCountState,
            recentMixesState = vm.recentMixesState,
            uploadCountState = vm.uploadCountState,
            unsavedDraftState = vm.unsavedDraftState,
            logo = logo,
            themeToggle = themeToggle,
            modifier = modifier,
            topBarActions = topBarActions,
            onNewMix = vm::userRequestedStartNewMix,
            onOpenMix = vm::userRequestedOpenMix,
            onSignOut = vm::userRequestedSignOut,
            content = content
        )
    }
}

@Composable
fun WMAppShellLayout(
    strings: WMWebStrings,
    activePath: String,
    pageTitle: String,
    sessionState: State<WMSession?>,
    planState: State<WMPlanSummary?>,
    mixCountState: State<Int?>,
    recentMixesState: State<List<WMStoredMix>>,
    uploadCountState: State<Int?>,
    unsavedDraftState: State<Boolean>,
    logo: @Composable () -> Unit,
    themeToggle: @Composable () -> Unit,
    modifier: Modifier = Modifier,
    topBarActions: (@Composable () -> Unit)? = null,
    onNewMix: () -> Unit,
    /** A mix in the sidebar's list was chosen; its link navigates. */
    onOpenMix: (mixId: String) -> Unit,
    onSignOut: () -> Unit,
    content: @Composable () -> Unit
) {
    var drawerOpen by remember { mutableStateOf(false) }
    val reducedMotion = remember { window.matchMedia("(prefers-reduced-motion: reduce)").matches }
    val colors = ColorMode.current.toPalette().fs
    // Opening another page closes the drawer; so does Escape while it is open.
    LaunchedEffect(activePath) { drawerOpen = false }
    if (drawerOpen) {
        DisposableEffect(Unit) {
            val onKeyDown: (org.w3c.dom.events.Event) -> Unit = { event ->
                if ((event as? KeyboardEvent)?.key == "Escape") {
                    drawerOpen = false
                }
            }
            document.addEventListener("keydown", onKeyDown)
            onDispose { document.removeEventListener("keydown", onKeyDown) }
        }
    }
    val sidebar: @Composable () -> Unit = {
        WMAppSidebarContent(
            strings = strings,
            activePath = activePath,
            session = sessionState.value,
            plan = planState.value,
            mixCount = mixCountState.value,
            recentMixes = recentMixesState.value,
            uploadCount = uploadCountState.value,
            logo = logo,
            themeToggle = themeToggle,
            onNewMix = {
                drawerOpen = false
                onNewMix()
            },
            onOpenMix = onOpenMix,
            onSignOut = onSignOut
        )
    }

    Row(modifier = Modifier.fillMaxWidth().minHeight(100.vh).backgroundColor(colors.background).then(modifier)) {
        // The sidebar keeps its width; the main column takes the rest and may shrink below its content.
        Box(Modifier.displayIfAtLeast(Breakpoint.LG).flexShrink(0)) { sidebar() }
        Column(modifier = Modifier.flexGrow(1).flexBasis(0.px).minWidth(0.px)) {
            WMAppTopBar(
                title = pageTitle,
                menuLabel = strings.common.menu,
                onMenuClick = { drawerOpen = true },
                status = {
                    if (unsavedDraftState.value && activePath.startsWith(WMRoutes.MIX)) {
                        WMBadge(strings.shell.unsavedMix, kind = WMBadgeKind.Warning, icon = WMIconGlyph.Pencil)
                    }
                },
                actions = topBarActions?.let { actions -> { actions() } }
            )
            Column(modifier = WMAppMainStyle.toModifier()) {
                WMShellRenewalReminder(strings, planState.value)
                content()
            }
        }
    }
    // The drawer below Large: always in the page so it can slide in and out; closed, it is `inert` (out of reach of
    // the keyboard and assistive technology).
    val motion = if (reducedMotion) WMNoTransitionStyle.toModifier() else Modifier
    Box(
        WMDrawerScrimStyle.toModifier()
            .thenIf(drawerOpen) { WMDrawerScrimOpenStyle.toModifier() }
            .then(motion)
            .displayUntil(Breakpoint.LG)
            .onClick { drawerOpen = false }
    )
    Box(
        WMDrawerStyle.toModifier()
            .thenIf(drawerOpen) { WMDrawerOpenStyle.toModifier() }
            .then(motion)
            .displayUntil(Breakpoint.LG)
            .attrsModifier {
                attr("aria-label", strings.common.menu)
                if (!drawerOpen) attr("inert", "")
            }
    ) {
        sidebar()
        WMIconButton(
            WMIconGlyph.X,
            accessibilityString = strings.common.closeMenu,
            modifier = WMDrawerCloseStyle.toModifier(),
            size = WMButtonSize.Sm,
            onClick = { drawerOpen = false }
        )
    }
}

@Composable
private fun WMAppSidebarContent(
    strings: WMWebStrings,
    activePath: String,
    session: WMSession?,
    plan: WMPlanSummary?,
    mixCount: Int?,
    recentMixes: List<WMStoredMix>,
    uploadCount: Int?,
    logo: @Composable () -> Unit,
    themeToggle: @Composable () -> Unit,
    onNewMix: () -> Unit,
    onOpenMix: (mixId: String) -> Unit,
    onSignOut: () -> Unit
) {
    val items = listOf(
        WMNavItem(strings.shell.mixBuilder, WMRoutes.MIX, WMIconGlyph.SlidersHorizontal, active = activePath == WMRoutes.MIX || activePath.startsWith("${WMRoutes.MIX}/")),
        WMNavItem(strings.shell.savedMixes, WMRoutes.MIXES, WMIconGlyph.Bookmark, active = activePath.startsWith(WMRoutes.MIXES), count = mixCount),
        WMNavItem(strings.shell.sharedLinks, WMRoutes.SHARED_LINKS, WMIconGlyph.Share2, active = activePath.startsWith(WMRoutes.SHARED_LINKS)),
        WMNavItem(strings.shell.jobDescriptions, WMRoutes.JOB_DESCRIPTIONS, WMIconGlyph.FileText, active = activePath.startsWith(WMRoutes.JOB_DESCRIPTIONS), count = uploadCount),
        WMNavItem(strings.shell.methodology, "/methodology", WMIconGlyph.BookOpen, active = activePath.startsWith("/methodology"))
    )
    // Penpot `App Sidebar` "mixes": the active one is the open route, matched the way the nav items are.
    val mixItems = recentMixes.map { mix ->
        val path = WMRoutes.mix(mix.id)
        WMNavItem(mix.title, path, active = activePath == path, onClick = { onOpenMix(mix.id) })
    }
    val lapsed = plan?.lapsed == true
    WMAppSidebar(
        logo = logo,
        items = items,
        modifier = Modifier.minHeight(100.vh),
        sectionHeading = if (lapsed) strings.renewal.sidebarMixesLocked else strings.shell.yourMixes,
        sectionItems = mixItems,
        showEmptySection = lapsed,
        primaryAction = {
            WMButton(strings.shell.newMix, fullWidth = true, leadingIcon = WMIconGlyph.Plus, onClick = onNewMix)
        },
        footer = {
            WMShellPlanCard(strings, plan)
            WMSidebarItem(WMNavItem(strings.shell.account, WMRoutes.ACCOUNT, WMIconGlyph.User, active = activePath.startsWith(WMRoutes.ACCOUNT)))
            Row(modifier = Modifier.fillMaxWidth().gap(8.px), verticalAlignment = Alignment.CenterVertically) {
                val themeLabel = WMLabelTextStyle.toModifier().fillMaxWidth().color(ColorMode.current.toPalette().fs.onSurfaceVariant)
                SpanText(strings.shell.theme, themeLabel)
                themeToggle()
            }
            WMShellIdentityRow(strings, session, onSignOut)
        }
    )
}


/** A lapsed account sees the renewal reminder above every app page (paid-feature plan W7). */
@Composable
internal fun WMShellRenewalReminder(strings: WMWebStrings, plan: WMPlanSummary?) {
    if (plan?.lapsed != true) {
        return
    }
    val lapsedPlan = plan.lapsedPlanName(strings)
    WMRenewalBanner(
        title = strings.renewal.bannerTitle,
        message = strings.renewal.bannerMessage,
        actionLabel = lapsedPlan?.let(strings.renewal.renewPlan) ?: strings.renewal.renew,
        onAction = { kotlinx.browser.window.location.href = WMRoutes.PRICING }
    )
}

/** The name of the plan a lapsed account had, which renewing brings back; `null` when it is not known. */
private fun WMPlanSummary.lapsedPlanName(strings: WMWebStrings): String? {
    return plan.takeIf { lapsed && it != WMSubscriptionType.None }?.let { strings.planName(it) }
}

/** The sidebar's plan card: Ended for a lapsed account, otherwise the plan, its uploads sentence (A5) and the upgrade. */
@Composable
internal fun WMShellPlanCard(strings: WMWebStrings, plan: WMPlanSummary?) {
    val planType = plan?.plan ?: WMSubscriptionType.None
    val quota = plan?.uploadQuota
    val used = plan?.uploadsUsed ?: 0
    val (label, text) = when (planType) {
        WMSubscriptionType.None -> strings.common.free to strings.shell.planFreeText
        WMSubscriptionType.Basic -> strings.common.basic to strings.shell.planBasicText(used, quota ?: 0)
        WMSubscriptionType.Pro -> strings.common.pro to strings.shell.planProText
    }
    val upgrade = if (planType == WMSubscriptionType.Basic) strings.common.upgradeToPro else strings.shell.upgrade
    val upgradeAction: @Composable () -> Unit = {
        WMButton(upgrade, kind = WMButtonKind.Secondary, size = WMButtonSize.Sm, fullWidth = true) {
            kotlinx.browser.window.location.href = WMRoutes.PRICING
        }
    }
    if (plan?.lapsed == true) {
        val lapsedPlan = plan.lapsedPlanName(strings)
        WMPlanSummaryCard(
            planLabel = strings.renewal.planEnded,
            text = lapsedPlan?.let(strings.renewal.planEndedTextOf) ?: strings.renewal.planEndedText,
            badgeKind = WMBadgeKind.Warning,
            action = {
                val renew = lapsedPlan?.let(strings.renewal.renewPlan) ?: strings.renewal.planRenew
                WMButton(renew, kind = WMButtonKind.Secondary, size = WMButtonSize.Sm, fullWidth = true) {
                    kotlinx.browser.window.location.href = WMRoutes.PRICING
                }
            }
        )
    } else {
        WMPlanSummaryCard(
            planLabel = label,
            text = text,
            meterFraction = if (quota != null && quota > 0) used.toDouble() / quota else null,
            meterLabel = if (quota != null && quota > 0) text else null,
            action = upgradeAction.takeIf { planType != WMSubscriptionType.Pro }
        )
    }
}

/** Who is signed in (avatar, name, email) with the log-out button on the same row (design deviation A2). */
@Composable
internal fun WMShellIdentityRow(strings: WMWebStrings, session: WMSession?, onSignOut: () -> Unit) {
    Row(modifier = Modifier.fillMaxWidth().gap(8.px), verticalAlignment = Alignment.CenterVertically) {
        session?.let {
            WMAvatar(
                initials = WMFormat.initials(it.displayName?.substringBefore(' '), it.displayName?.substringAfter(' ', ""), fallback = it.email.take(1).uppercase()),
                accessibilityString = it.displayName ?: it.email
            )
            Column(modifier = Modifier.fillMaxWidth().minWidth(0.px)) {
                it.displayName?.takeIf { name -> name.isNotBlank() }?.let { name -> SpanText(name, WMLabelStrongTextStyle.toModifier().then(WMEllipsisStyle.toModifier())) }
                SpanText(it.email, WMCaptionTextStyle.toModifier().color(ColorMode.current.toPalette().fs.onSurfaceVariant).then(WMEllipsisStyle.toModifier()))
            }
        }
        WMIconButton(WMIconGlyph.LogOut, accessibilityString = strings.shell.logOut, size = WMButtonSize.Sm, onClick = onSignOut)
    }
}

/** One line that ends in an ellipsis when it does not fit (the sidebar's name and email). */
val WMEllipsisStyle = CssStyle.base {
    Modifier.whiteSpace(WhiteSpace.NoWrap).overflow(Overflow.Hidden).textOverflow(TextOverflow.Ellipsis)
}
